<template>
  <header class="header">
    <div class="header__logo-container" :class="modifierClass">
      <div class="header__logo">
        <router-link to="/dashboard">
          <img src="/images/fuel-logo.png" alt="Fuel Member Portal" class="header__logo-img" />
        </router-link>
      </div>
    </div>
    <div class="header__content-container" :class="`header__content-container--${modifierClass}`">
      <div class="header__logo-angle-block"></div>
      <div class="header__content">
        <span class="header__section-indicator-icon h-display-inline-block"><i class="fa" :class="icon"></i></span>
        <div class="header__section-title h-display-inline-block">{{ activeSectionObject.title }}</div>
        <VersionIndicator v-if="devEnv"></VersionIndicator>
      </div>
      <div class="header__member-menu-container" :class="[{ 'header__end-container--hover': children.length }, `header__member-menu-container--${modifierClass}`]">
        <div class="header__member-menu" :class="[{ 'header__end-container--hover': children.length }, `header__member-menu--${modifierClass}`]">
          <ChildSelect v-if="children.length"></ChildSelect>
          <div class="header__member-name" v-else v-html="memberName"></div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import VersionIndicator from '../header/VersionIndicator.vue';
  import ChildSelect from '../header/ChildSelect.vue';

  export default {
    name: 'Header',
    components: {
      VersionIndicator,
      ChildSelect,
    },
    computed: {
      ...mapGetters('main', [
        'devEnv',
        'baseUrl',
        'activeSection',
        'children',
        'memberName',
        'menuItems',
        'meetingAttendee',
      ]),
      routeName() {
        // account for case where meetingAttendee guest is accessing the portal
        if (this.meetingAttendee) {
          return lodash.replace(this.$route.path, /^\//, '');
        }

        return this.$route.path.replace(/^\//, '').split('/')[0];

        // handle all other use cases (meeting-agenda and meeting-agendas both come from the same permission/menu item)
        // return this.$route.name === 'meeting-agenda' ? 'meeting-agendas' : this.$route.name;
      },
      activeSectionObject() {
        return lodash.find(this.menuItems, { url: this.routeName });
      },
      icon() {
        return this.activeSectionObject ? this.activeSectionObject.icon : '';
      },
      modifierClass() {
        return this.activeSectionObject ? lodash.kebabCase(this.activeSectionObject.title.toLowerCase()) : '';
      },
    },
  }
</script>
